// extracted by mini-css-extract-plugin
export default {"list_menu":"index_list_menu_3cVBT","morehNew":"index_morehNew_y9uPf","more":"index_more_S-dsQ"};